import { toast } from "react-toastify";

import { DataUpIcon, Share } from "../../assets/icons";

const Invitation = () => {
  const shareLink = async () => {
    const link = window.location.origin;
    let usedShare = false;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "DataUp",
          text: "Join the DataUp Family.",
          url: link,
        });
        usedShare = true;
        return;
      } catch (error) {
        // Fall back to copy if share is canceled or fails.
      }
    }

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(link);
        if (!usedShare) {
          toast.success("Link copied to clipboard.");
        }
        return;
      } catch (error) {
        // Fallback to manual copy below.
      }
    }

    const textarea = document.createElement("textarea");
    textarea.value = link;
    textarea.setAttribute("readonly", "true");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    if (!usedShare) {
      toast.success("Link copied to clipboard.");
    }
  };

  return (
    <div
      className="relative py-6 px-4 rounded-lg col-6"
      style={{
        backgroundImage: `url(/images/invitation.jpeg)`,
        backgroundPosition: "center top", // Focus on the top-center part of the image
        backgroundSize: "100% 100%", // Stretch the image height to 200% so the top 50% is visible
        backgroundRepeat: "no-repeat",
      }}
    >
      <img
        src="/png/IVCartoon.png"
        alt=""
        className="absolute -top-8 -right-3 size-32 rtransform scale-x-[-1]"
      />
      <div className="col-4">
        <DataUpIcon />
        <span className="lt-xl-medium-white z-10">
          Invite your friends and family to join the DataUp Family
          {/* and earn rewards on their first
          purchase. */}
        </span>
      </div>
      <button
        className="row-3 h-10 rounded-lg py-[10px] px-4 bg-white place-content-center"
        onClick={shareLink}
        type="button"
      >
        <span className="satoshi-sm-bold-toggleBG-dark">Share Link</span>
        <Share />
      </button>
    </div>
  );
};

export default Invitation;
